const PLANNERROUTES = {
  GETCLIENTLIST: `clients/client/basic/advanced/all`,
};

export default PLANNERROUTES;
